import * as React from 'react';

import { PieChart } from 'react-native-svg-charts';
import { Circle, G, Line, Text as SText } from 'react-native-svg';
import { Toast } from 'native-base';

const PieLabels = ({ slices }) => {
	return slices.map((slice, index) => {
		const { labelCentroid, pieCentroid, data } = slice;
		return (
			<G key={`i${index}`}>
				<Line x1={labelCentroid[0]} y1={labelCentroid[1]} x2={pieCentroid[0]} y2={pieCentroid[1]} stroke={data.svg.fill} />
				<Circle cx={labelCentroid[0]} cy={labelCentroid[1]} r={2} fill={data.svg.fill} />
				<SText
					x={labelCentroid[0] + (labelCentroid[0] > pieCentroid[0] - 10 ? 5 : -5)}
					y={labelCentroid[1] + (labelCentroid[1] > pieCentroid[1] ? 2 : -2)}
					fill={data.svg.fill}
					stroke={'black'}
					strokeWidth={0.2}
					textAnchor={labelCentroid[0] > pieCentroid[0] - 10 ? 'start' : 'end'}
					alignmentBaseline={'middle'}
					fontSize={11}>
					{data.label}
				</SText>
			</G>
		);
	});
};

function randomColor() {
	return ('#' + ((Math.random() * 0xffffff) << 0).toString(16) + '000000').slice(0, 7);
}

export default function ExpensePie({ pdata, yearText }) {
	const onPiePress = (v, i) => {
		const rec = pdata[i];

		//console.log(this.props, rec, this.props.currYear);
		Toast.show({
			text: `You spent £${rec.payable} on ${rec.categoryName} in ${yearText},\nOf which £${rec.paid} was paid.`,
			position: 'bottom',
			buttonText: 'Okay'
		});
	};
	const pieData = pdata
		//.filter(value => value > 0)
		.map((value, index) => ({
			//value,
			amount: value.payable,
			label: value.categoryName,
			svg: {
				fill: randomColor(),
				onPress: () => onPiePress(value, index)
				//arc: { outerRadius: '130%', cornerRadius: 10,  }
			},
			//color: this.randomColor(),
			key: `pie-${index}`
		}));

	return (
		<PieChart
			style={{ height: 200, position: 'absolute', left: 0, right: 0 }}
			valueAccessor={({ item }) => item.amount} // 4.0.0 only relies on react-native-svg@^6.2.1
			data={pieData}
			spacing={0}
			innerRadius={20}
			outerRadius={70}
			labelRadius={80}>
			<PieLabels />
		</PieChart>
	);
}
